import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonLink from 'components/shared/ButtonLink.styled';
import { Heading1 } from 'components/shared/Typography';
import { LoggedUserContext } from 'context/logged-user/loggeduser.context';
import { useI18n } from 'hooks/useI18n';
import { useRouter } from 'next/dist/client/router';
import Link from 'next/link';
import { useContext } from 'react';
import { APP_URLS, getAppUrl } from 'utils/app-urls';
import { getPublicPath } from 'utils/paths';
import { StyledImage, StyledIntro } from './ManfrediteIntro.styled';

const ManfrediteIntro: React.FC = () => {
  const { t } = useI18n('manfredite');
  const { locale } = useRouter();

  const { user } = useContext(LoggedUserContext);

  return (
    <StyledIntro>
      <StyledImage
        src={getPublicPath('/images/manfredite/manfredite-intro.svg')}
        alt=""
      />
      <Heading1 editorial>{t('intro.title')} </Heading1>
      <p>{t('intro.description')}</p>
      {!user && (
        <Link
          href={`${getAppUrl(APP_URLS.join, locale)}?locale=${locale}`}
          passHref
        >
          <ButtonLink variant="brandTalent">
            <FontAwesomeIcon icon={faCheckCircle} />
            <span>{t('intro.cta')}</span>
          </ButtonLink>
        </Link>
      )}
    </StyledIntro>
  );
};

export default ManfrediteIntro;
